import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { TEXTAREA_ROW_LENGTH } from '../../../constants/constants';
import validAllowedCharacters from '../../../constants/valid-character-password';
import IAddFactory from '../../../models/forms/IAddUpdateFactory';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormTextArea from '../../../shared-components/FormikFormHandlers/FormikFormTextArea';
import { UpdateTenantDetailsValidateSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import './add-edit-factory-form.css';

const UpdateFactoryForm = (props: IAddEditFormProps<IAddFactory>) => {
  return (
    <Formik
      initialValues={props.initialValues}
      onSubmit={props.submitHandler}
      validationSchema={UpdateTenantDetailsValidateSchema}
      validateOnBlur={false}
      enableReinitialize
    >
      {({ handleSubmit, handleBlur, handleChange }) => (
        <Form
          id="formBody"
          onSubmit={handleSubmit}
        >
          {props.isLoading && <FormLoader loading={props.isLoading} />}

          <Modal.Body>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={true}
                    label="factory_name"
                  />
                  <Field
                    data-testid="FactoryName"
                    className="form-control"
                    name="FactoryName"
                    placeholder=""
                    type="text"
                    validcharacter={validAllowedCharacters}
                    as={FormikFormInput}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={false}
                    label="factory_city"
                  />
                  <Field
                    data-testid="OrganizationName"
                    className="form-control"
                    name="FactoryCity"
                    placeholder=""
                    type="text"
                    validcharacter={validAllowedCharacters}
                    as={FormikFormInput}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-md-4 col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    label="factory_country"
                  />
                  <Field
                    data-testid="FactoryCountry"
                    className="form-control"
                    name="FactoryCountry"
                    disabled={true}
                    placeholder=""
                    type="text"
                    validcharacter={['@', '#', '$', '-', '_', '.']}
                    as={FormikFormInput}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={false}
                    label="location"
                  />
                  <Field
                    rows={TEXTAREA_ROW_LENGTH}
                    id="FactoryAddress"
                    className="form-control"
                    name="FactoryAddress"
                    placeholder=""
                    type="text"
                    as={FormikFormTextArea}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>

          <ModalFooter
            id={props.id}
            onModalClosed={props.onModalClosed}
            isLoading={props.isLoading}
            saveNextBtn="update"
            backCancelBtn="cancel"
          />
        </Form>
      )}
    </Formik>
  );
};

export default UpdateFactoryForm;
